<div class="game-community">
  <header class="game-community__header">
    <h2 class="game-community__title">{{ copy.communityTitle }}</h2>
    <p class="game-community__subtitle">{{ subtitle() }}</p>
  </header>

  <!-- Próximos eventos: hasta 6, propios primero y rellenados con los de la
       tienda y otros juegos si no llegan (D3), pero pintados por fecha (D8).
       La zona solo desaparece si propios y relleno vienen ambos vacíos. -->
  @if (hasEvents()) {
    <div class="game-community__zone">
      <h3 class="game-community__zone-title">
        <app-icon [icon]="trophyIcon" [size]="20" />
        {{ copy.upcomingEventsLabel }}
      </h3>
      <div class="game-community__tournaments">
        @for (item of displayEvents(); track item.event.id) {
          <!-- Acento y chip son la misma señal y se deciden en el mismo sitio:
               de aquí = acento del juego y sin chip; de fuera = acento neutro
               y con chip. Un caso mixto es un bug (D3 + D9). -->
          <div
            class="tournament-card"
            [class.tournament-card--filler]="item.isFiller"
            [style.--game-accent-color]="accentFor(item)"
          >
            <div class="tournament-card__icon-wrap">
              <app-icon [icon]="calendarIcon" [size]="24" />
            </div>
            <div class="tournament-card__body">
              <span class="tournament-card__tags">
                <span class="tournament-card__type">{{ eventType(item.event) }}</span>
                @if (item.isFiller) {
                  <span
                    class="tournament-card__game"
                    [class.tournament-card__game--store]="!item.event.game"
                    >{{ chipLabel(item.event) }}</span
                  >
                }
              </span>
              <span class="tournament-card__name">
                <!-- Único tab stop de la tarjeta: el botón se estira sobre ella
                     entera (::after) y abre el detalle del evento. -->
                <button
                  type="button"
                  class="tournament-card__open"
                  aria-haspopup="dialog"
                  [attr.aria-label]="openLabel(item.event)"
                  (click)="openDetails(item.event)"
                >
                  {{ item.event.name }}
                </button>
              </span>
              <span class="tournament-card__meta">{{ eventMeta(item.event) }}</span>
              @if (eventPrice(item.event); as price) {
                <span class="tournament-card__price">{{ price }}</span>
              }
            </div>
            <span class="tournament-card__location">{{ item.event.location }}</span>
          </div>
        }
      </div>
      <a class="game-community__events-cta" [routerLink]="eventsLink()">
        {{ copy.allEventsCta }}
      </a>
    </div>
  }

  <!-- Comunidad online -->
  @if (content().onlineLinks.length > 0) {
    <div class="game-community__zone">
      <h3 class="game-community__zone-title">
        <app-icon [icon]="usersIcon" [size]="20" />
        {{ copy.onlineLinksLabel }}
      </h3>
      <div class="game-community__channels">
        <!-- `track link.url`: dos enlaces de la misma plataforma (p. ej. dos
             grupos de WhatsApp) romperían un track por `platform`. -->
        @for (link of content().onlineLinks; track link.url) {
          <a
            [href]="link.url"
            class="community-link"
            [attr.data-platform]="link.platform"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="link.label"
          >
            <div class="community-link__icon-wrap">
              <app-icon [icon]="platformIcon(link.platform)" [size]="24" />
            </div>
            <div class="community-link__body">
              <span class="community-link__name">{{ link.label }}</span>
              @if (link.memberCount) {
                <span class="community-link__members">{{ link.memberCount }}</span>
              }
            </div>
            <span class="community-link__cta">{{ copy.communityLinkCta }}</span>
          </a>
        }
      </div>
    </div>
  }

  <!-- Tiendas y lugares -->
  @if (content().localStores.length > 0) {
    <div class="game-community__zone">
      <h3 class="game-community__zone-title">
        <app-icon [icon]="mapPinIcon" [size]="20" />
        {{ copy.localStoresLabel }}
      </h3>
      <div class="game-community__stores">
        @for (store of content().localStores; track store.name) {
          <div class="store-card">
            <div class="store-card__icon-wrap">
              <app-icon [icon]="mapPinIcon" [size]="24" />
            </div>
            <div class="store-card__body">
              <span class="store-card__name">{{ store.name }}</span>
              <span class="store-card__address">{{ store.address }}</span>
              @if (store.scheduleNote) {
                <span class="store-card__schedule">{{ store.scheduleNote }}</span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Teaser + Mascota -->
  <div class="game-community__teaser-row">
    <div class="game-community__teaser">
      <div class="game-community__teaser-icon-wrap">
        <app-icon [icon]="usersIcon" [size]="24" />
      </div>
      <div class="game-community__teaser-body">
        <span class="game-community__teaser-title">{{ copy.communityTeaser }}</span>
        <span class="game-community__teaser-text">
          Pronto podrás activar tu perfil para que otros jugadores de tu zona te encuentren y organizar partidas. Filtra por provincia, cantón y distrito para encontrar con quién jugar.
        </span>
      </div>
    </div>

    @if (!mascotError()) {
      <div class="game-community__mascot">
        <img
          src="images/logo/comunity.png"
          alt="Mascota Perrón aprendiendo a jugar"
          loading="lazy"
          class="game-community__mascot-img"
          (error)="onMascotError()"
        />
      </div>
    }
  </div>
</div>
